<template>
    <div class="page">
        <tabs :tabs="tabs" />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import featureFlags from '@enums/feature-flags';
import routeNames from '@enums/route-names';

export default {
    computed: {
        ...mapState('clientConfig', ['toggleLogic']),

        canOnlyAccessUserProfiles() {
            return this.toggleLogic[featureFlags.reportingOnly];
        },

        tabs() {
            let tabs = [];
            let clientSystemsTestingTab = [];
            let adminToolsTabs = [];
            if (!this.canOnlyAccessUserProfiles) {
                if (this.toggleLogic[featureFlags.canAccessAdminArea]) {
                    tabs = [
                        ...(this.toggleLogic[featureFlags.canManageOfferMechanicPresets]
                            ? [
                                  {
                                      label: this.toSentenceCase(
                                          this.$t('admin.tabs.offerPresets')
                                      ),
                                      disabled: false,
                                      component: 'offer-presets-admin',
                                      routeNames: [routeNames.offerPresetsAdmin],
                                      path: '/admin/offer-presets',
                                  },
                              ]
                            : []),
                        {
                            label: this.toSentenceCase(this.$t('admin.tabs.rateCard')),
                            disabled: false,
                            component: 'rate-card',
                            routeNames: [routeNames.rateCardView],
                            path: '/admin/rate-card',
                        },
                        {
                            label: this.toSentenceCase(this.$t('admin.tabs.freeGifts')),
                            disabled: false,
                            component: 'free-gifts-viewer',
                            routeNames: [routeNames.freeGiftsView],
                            path: '/admin/free-gifts',
                        },
                        {
                            label: this.toSentenceCase(this.$t('admin.tabs.loyaltyPoints')),
                            disabled: false,
                            component: 'loyalty-points-viewer',
                            routeNames: [routeNames.loyaltyPointsView],
                            path: '/admin/loyalty-points',
                        },
                    ];
                }

                if (this.toggleLogic[featureFlags.canAccessClientSystemsTesting]) {
                    clientSystemsTestingTab = [
                        {
                            label: this.toSentenceCase(this.$t('admin.tabs.clientSystemsTesting')),
                            disabled: false,
                            linkText: 'navBar.clientSystemsTesting',
                            omitFromNav: true,
                            component: 'client-systems-testing',
                            path: 'client-systems-testing',
                            routeNames: [routeNames.clientSystemsTesting],
                        },
                    ];
                }

                if (this.toggleLogic[featureFlags.canAccessAdminTools]) {
                    adminToolsTabs = [
                        {
                            label: this.toSentenceCase(this.$t('admin.tabs.redisBull')),
                            disabled: false,
                            linkText: 'navBar.redisBull',
                            omitFromNav: true,
                            component: 'redis-bull',
                            path: 'redis-bull',
                            routeNames: [routeNames.redisBull],
                        },
                        {
                            label: this.toSentenceCase(this.$t('admin.tabs.featureToggler')),
                            disabled: false,
                            linkText: 'navBar.featureToggler',
                            omitFromNav: true,
                            component: 'feature-toggler',
                            path: 'feature-toggler',
                            routeNames: [routeNames.featureToggler],
                        },
                        {
                            label: this.toSentenceCase(this.$t('admin.tabs.configEditor')),
                            disabled: false,
                            omitFromNav: true,
                            component: 'config-editor',
                            path: 'config-editor',
                            routeNames: [routeNames.configEditorView],
                        },
                    ];
                }
            }

            const userPermissionTab = this.toggleLogic[featureFlags.canAccessAdminArea]
                ? [
                      {
                          label: this.toSentenceCase(this.$t('admin.tabs.userPermissions')),
                          disabled: false,
                          linkText: 'navBar.userPermissions',
                          omitFromNav: true,
                          component: 'user-permissions',
                          routeNames: ['userPermissions'],
                          path: '/admin/userPermissions',
                      },
                  ]
                : [];

            return [...tabs, ...userPermissionTab, ...clientSystemsTestingTab, ...adminToolsTabs];
        },
    },
};
</script>

<style scoped lang="scss">
.page {
    height: 100%;
    padding: 0 1rem;
    padding-top: 2rem;
}

// Vuetify overrides needed for making the tabs fill the available vertical space.
:deep(.v-tabs.promo-tabs.v-theme--light) {
    height: 100%;
    display: flex;
    flex-direction: column;
}

:deep(.v-item-group.v-theme--light.v-slide-group.v-tabs-bar.primary--text.transparent) {
    flex: 0 1 0;
}

:deep(.v-window.v-item-group.v-theme--light.v-tabs-items) {
    flex: 1 0 0;
}

:deep(.v-window__container) {
    height: 100%;
}

:deep(.v-window-item.tab.v-window-item--active) {
    height: 100%;
}
</style>
